<template>
    <!-- <v-row
        class="pa-0 d-flex overflow-scroll h-100"
        :style="{
            backgroundImage: `url(${contextual_image})`
        }"
        justify="center"
        :id="`book-container`"
    > -->
    <v-row
        class="pa-0 d-flex ma-0"
        justify="center"
        :id="`book-container`"
        >
        <!-- {{book.textType.name}} -->
        <HeaderMovil v-if="showMobile && book && book.textType && book.textType.name !== 'Revista'" />
        <v-card :class="[book && book.textType && book.textType.name !== 'Revista' ? 'mt-4' : 'bg-none', showMobile ? 'ma-0' : '' , 'reading-card']">
            <HeaderDesk v-if="!showMobile && book && book.textType && book.textType.name !== 'Revista'" />

            <vue-headful :title="$t('title_bookReading')" description="title" />
            <v-row
                :class="`${
                    currentStage === 'bookCover' ? 'd-flex' : 'd-none'
                } ma-7 flex-column`"
                justify="center"
            >
                <BookInitCard
                    v-if="book"
                    :book="book"
                    :avgRating="avgRating"
                    :userRating="userRating"
                />
            </v-row>
            <v-row
                :class="`${
                    currentStage === 'bookReading' ? 'd-flex' : 'd-none'
                } mx-7 mb-7 flex-column`"
                justify="center"
            >
                <MainContainer v-if="book" />
            </v-row>
            <v-row
                :class="`${
                    currentStage === 'bookEnd' ? 'd-flex' : 'd-none'
                } ma-7 flex-column`"
                justify="center"
            >
                <BookFinishCard :book="book" />
            </v-row>
        </v-card>
    </v-row>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'

import BookService from '@/services/book'
import BookUserFavoriteService from '@/services/bookUserFavorite'
import BookRatingService from '@/services/bookRating'
import LinguisticVariableService from '@/services/linguisticVariable'

import BookInitCard from '@/components/reading/BookInitCard.vue'
import BookFinishCard from '@/components/reading/BookFinishCard.vue'
import MainContainer from '@/components/reading/content/MainContainer.vue'
import HeaderMovil from '@/components/reading/content/Header.vue'
import HeaderDesk from '@/components/reading/content/HeaderDesk.vue'

// eslint-disable-next-line camelcase
import { backend_responses } from '@/constants/DefaultConstants'

import AnalyticEventsMixin from "../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    props: {
        book_id: { type: [String, Number], default: '' },
        magic_link_token: { type: [String], default: '' },
    },
    mixins: [AnalyticEventsMixin],
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            book: (state) => state.bookReading.book,
            currentStage: (state) => state.bookReading.currentStage,
            bookFavoriteForUser: (state) => state.bookReading.bookFavoriteForUser,
            bookCategories: (state) => state.bookReading.bookCategories,
            epubPagesLoaded: (state) => state.bookReading.epubPagesLoaded,
            pagesLoaded: (state) => state.bookReading.pagesLoaded,
            assignedBookId: (state) => state.userData.assignedBookId,
            showMobile: (state) => state.isMobile,
        }),
        isFavorite() {
            return this.bookFavoriteForUser
        },
        contextual_image() {
            let contextImg = '';
            if (this.book) {
                const { fromAge } = this.book;
                if (fromAge < 8) {
                    contextImg = '/img/context/6.png';
                } else if (fromAge <= 8) {
                    contextImg = '/img/context/8.png';
                } else if (fromAge <= 11) {
                    contextImg = '/img/context/11.png';
                } else if (fromAge <= 13) {
                    contextImg = '/img/context/13.png';
                } else if (fromAge <= 15) {
                    contextImg = '/img/context/13.png';
                } else {
                    contextImg = '/img/context/16.png';
                }
            }
            return contextImg
        },
    },
    watch: {
        isFavorite(newValue) {
            this.setBookFavorite(newValue)
        },
    },
    components: {
        BookInitCard,
        MainContainer,
        BookFinishCard,
        HeaderMovil,
        HeaderDesk,
    },
    beforeDestroy() {
        this.resetBookReadingState()
    },
    async mounted() {
        const bookRatingData = await BookRatingService.getRatingsByBook({ bookId: this.book_id })
        const linguisticVariableData = await LinguisticVariableService.getVariablesByBookId( this.book_id )
        if (bookRatingData && bookRatingData.content) {
            this.setBookRatingData(bookRatingData.content.content)
            this.setTotalRating(bookRatingData.content.totalElements)
        }

        const magiclink = this.$route.query.magiclink || ''

        this.setLinguisticVariables(linguisticVariableData.content)
        const assignmentType = Number.parseInt(this.assignedBookId, 10) === Number.parseInt(this.book_id, 10)
            ? 'SCHOOL'
            : 'MYSELF'
        await BookService.getBookSummaryInfo(this.book_id, this.user.id, assignmentType, magiclink)
            .then((response) => {
                if (backend_responses[response.status.code] === 'ERROR') {
                    throw new Error(this.$t('general.error_msg'))
                }
                const {
                    bookDTO,
                    bookUserCatalogDTO,
                    bookUserHighlightDTOList,
                    bookAssessmentItemDTOList,
                    bookUserReadConfDTO,
                    bookFavoriteForUser,
                    metaDataCategoryDTOList,
                    bookUserNotesDTOList,
                    avgRating,
                    bookRatingDTO,
                } = response.content
                this.setBook(bookDTO)
                this.setCatalog(bookUserCatalogDTO)
                this.setHighlightData(bookUserHighlightDTOList)
                this.setBookAssessmentData(bookAssessmentItemDTOList)
                this.setBookReadConf(bookUserReadConfDTO)
                this.setBookFavoriteForUserValue(bookFavoriteForUser)
                this.setBookCategories(metaDataCategoryDTOList)
                this.setBookUserNotes(bookUserNotesDTOList)
                this.avgRating = avgRating
                this.userRating = bookRatingDTO
            })
            .catch((error) => {
                Sentry.captureException(error)
                this.$modal.loadError()
            })
        if (this.book && this.book.formatType === 'EPUB') {
            this.getEpubContent()
        }
        this.createAnalyticEvent(AnalyticEventTypes.GoToReadBook)
    },
    methods: {
        ...mapActions('bookReading', [
            'setBook',
            'setCatalog',
            'setHighlightData',
            'setBookAssessmentData',
            'setBookReadConf',
            'setBookFavoriteForUserValue',
            'setBookCategories',
            'resetBookReadingState',
            'setBookUserNotes',
            'setEpubPages',
            'setBookRatingData',
            'setTotalRating',
        ]),
        ...mapActions('common', ['setLinguisticVariables']),
        setBookFavorite(value) {
            if (value){
                this.$ga.event('userClick', 'bookFavorite', 'Add book to favorite')
                BookUserFavoriteService.addFavoriteBookToUser({
                    user: { id: this.user.id },
                    book: { id: this.book.id },
                }).catch((error) => Sentry.captureException(error))
            } else {
                this.$ga.event('userClick', 'bookUnFavorite', 'remove book from favorites')
                BookUserFavoriteService.deleteFavoriteBookToUser(
                    this.user.id,
                    this.book.id
                ).catch((error) => Sentry.captureException(error))
            }
        },
        async getEpubContent() {
            const vm = this
            await BookService.getEPUBBookContent(this.book.resourceDir)
                .then(async (response) => {
                    const content = await response.text()

                    const div = document.createElement('div')
                    div.innerHTML = content
                    const manifest = div.querySelector('manifest')
                    const spine = div.querySelector('spine')

                    spine.querySelectorAll('itemref').forEach((value, index) => {
                        const idref = value.getAttribute('idref')
                        console.debug('idref: ', idref)

                        const page = {
                            number: index + 1,
                            idref,
                            href: null,
                        }
                        vm.epubPages.push(page)
                    })

                    vm.epubPages.forEach((page) => {
                        const { idref } = page
                        page.href = manifest
                            .querySelector(`item[id="${idref}"]`)
                            .getAttribute('href')
                    })

                    vm.setEpubPages(vm.epubPages)
                })
                .catch((error) => Sentry.captureException(error))
        },
    },
    data() {
        return {
            avgRating: null,
            userRating: null,
            epubPages: [],
            urlAssets: process.env.VUE_APP_BEEREADERS_ASSETS_URL
        }
    },
}
</script>
<style lang="scss">
#book-container{
    /* background: #efefef; */
    /* min-height: 100vh;
    background-position: center;
    background-repeat: repeat;
    background: rgb(81,71,115);
    background: linear-gradient(90deg, rgba(81,71,115,1) 0%, rgba(250,235,215,1) 35%, rgba(255,255,255,1) 100%); */
}
.reading-card{
    box-shadow: initial!important;
    // margin: 2.5rem 0 0;
    width: 100%;
    @media screen and (min-width: 768px){
        margin: 0 5.6em 0 1.6em;
        width: calc(100% - 5.6em);
    }
}
</style>
